import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
import { getLink } from '@frameio/shared/routing';
import type { SearchGetLinkParams } from '@frameio/shared/routing/pages/search';
import { useIsAdvancedSearchM2Enabled } from './useIsAdvancedSearchM2Enabled';

type SetRequestVariableParamsProps = {
  query: string;
  filters?: SearchGetLinkParams['filters'];
  projectId?: string | null;
  mode?: 'standard' | 'ai';
  // @todo (SRCH-2455): Remove legacy tab input after M2 rollout.
  tab?: 'standard' | 'ai';
  highlightStart?: number | null;
  highlightEnd?: number | null;
};

export const useSetRequestVariableParams = () => {
  const router = useRouter();
  // @todo (SRCH-2455): Always emit mode after rollout.
  const isM2Enabled = useIsAdvancedSearchM2Enabled();

  return useCallback(
    ({
      query,
      filters,
      projectId,
      tab,
      mode,
      highlightStart,
      highlightEnd,
    }: SetRequestVariableParamsProps) => {
      if (!query) return;

      const path = getLink({
        page: 'search',
        query,
        filters,
        projectId,
        // @todo (SRCH-2455): Remove the flag-off tab branch after rollout.
        ...(isM2Enabled ? { mode: mode ?? tab } : { tab: tab ?? mode }),
        highlightStart,
        highlightEnd,
      });
      router.replace(path, { scroll: false });
    },
    [router, isM2Enabled]
  );
};
